import $ from 'jquery';

const setupMobileToggleClickHandler = () => {
  $('.support__nav .nav__main__toggle').on('click', () => {
    document.body.classList.toggle('support__nav__mobile--active');
  });
};

const headerNav = {
  init() {
    setupMobileToggleClickHandler();
  }
};

export default headerNav;
